module.exports = __webpack_public_path__ + "img/result-detail-invest-inleft03.521a8ed4.svg";